<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul>
          <li>
            eGas · QSStorage
          </li>
        </ul>
      </nav>
      <div class="copyright d-flex flex-wrap">
        &copy; eGas Todos los derechos reservados
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
.container-fluid {
  width: 90% !important;
}
</style>
